import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { GridExpandMoreIcon } from '@mui/x-data-grid';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';
import errorFormat from '../../../../../utils/errorFormat';
import configSiteUrls from '../../../configs/configSiteUrls';
import {
  useAddPublicacaoOficialAnexosMutation,
  useAddPublicacaoOficialVereadoresMutation,
  useGetPublicacaoOficialAnexosQuery,
  useGetPublicacaoOficialVereadoresQuery,
  useRemovePublicacaoOficialAnexoExcluidoMutation
} from '../publicaoOficialAnexoApiSlice';
import { ISpublicacaoOficial, PublicacaoOficial, PublicacaoOficialDTO } from '../types/PublicacaoOficial';
import { PublicacaoOficialAnexo } from '../types/PublicacaoOficialAnexo';

import { useAddPublicacaoOficialMutation, useGetPublicacaoOficialQuery } from './publicacaoOficialApiSlice';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import TxtTipoPublicacaoOficialSite from '../../../../autoComplete/TxtTipoPublicacaoOficialSite';
import { IStipoPublicacaoOficial, TipoPublicacaoOficial, TipoPublicacaoOficialList } from '../../../../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';
import { PublicacaoOficialVereadorDTO, PublicacaoOficialVereadorList } from '../types/PublicacaoOficialVereador';
import PublicacaoOficialVereadorComponent from './PublicacaoOficialVereadorComponent';

export const PublicacaoOficialCreate = () => {
  const [publicacaoOficial, SetPublicacaoOficial] = useState<PublicacaoOficial>(ISpublicacaoOficial);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createPublicacaoOficial, status] = useAddPublicacaoOficialMutation();
  const [loading, setLoading] = useState(false);
  const [createAnexos, statusCreateAnexos] = useAddPublicacaoOficialAnexosMutation();
  const [createVereadores, statusCreateVereadores] = useAddPublicacaoOficialVereadoresMutation();
  const [removeAnexosExcluidos, statusRemoveExcluido] = useRemovePublicacaoOficialAnexoExcluidoMutation();
  const navigate = useNavigate();

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetPublicacaoOficialQuery(id);
  useEffect(() => {
    if (data) {
      SetPublicacaoOficial(data);
      setTipoPublicacaoOficialSelecionado(data.tipo);
    }
  }, [data, error, isFetching]);

  const [tipoPublicacaoOficialSelecionado, setTipoPublicacaoOficialSelecionado] = useState<TipoPublicacaoOficial>(IStipoPublicacaoOficial);
  const [publicacaoOficialAnexoParaSalvar, setPublicacaoOficialAnexoParaSalvar] = useState<File[]>([]);
  const [publicacaoOficialAnexoSalvo, setPublicacaoOficialAnexoSalvo] = useState<PublicacaoOficialAnexo[] | null>(null);
  const [publicacaoOficialVereador, setPublicacaoOficialVereador] = useState<PublicacaoOficialVereadorList[] | null>(null);

  const { data: dataAnexo } = useGetPublicacaoOficialAnexosQuery({ idPublicacaoOficial: id });
  useEffect(() => {
    if (dataAnexo) {
      setPublicacaoOficialAnexoSalvo(dataAnexo);
    }
  }, [dataAnexo]);

  const { data: dataVereadores } = useGetPublicacaoOficialVereadoresQuery({ idPublicacaoOficial: id });
  useEffect(() => {
    if (dataVereadores) {
      const normalizado = dataVereadores.map(item => ({
        ...item,
        excluido: false
      }));

      setPublicacaoOficialVereador(normalizado);
    }
    // if (dataVereadores) setPublicacaoOficialVereador(dataVereadores);
  }, [dataVereadores]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    if (name === 'exercicio') {
      // Só números
      const somenteNumeros = value.replace(/\D/g, '').slice(0, 4);

      SetPublicacaoOficial(prev => ({
        ...prev,
        exercicio: somenteNumeros === '' ? null : Number(somenteNumeros)
      }));

      e.target.value = somenteNumeros;

      // Mantém o cursor no local correto
      setTimeout(() => {
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }, 0);

      return;
    }

    // Demais campos
    SetPublicacaoOficial(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setPublicacaoOficialAnexoParaSalvar(prev => [...prev, ...convertedFiles]);
  };

  const handleOnDeleteParaSalvar = (index: number) => {
    setPublicacaoOficialAnexoParaSalvar(prev => prev.filter((_, i) => i !== index));
  };

  function handleOnDeleteSalvo(fileId: string) {
    setPublicacaoOficialAnexoSalvo(prev => {
      if (prev) {
        return prev.map(arq => (arq.id === fileId ? { ...arq, excluido: true } : arq));
      }
      return null; // ou um array vazio se preferir
    });
  }

  const handleExcluirTodosAnexos = () => {
    setPublicacaoOficialAnexoParaSalvar([]);
    setPublicacaoOficialAnexoSalvo(null);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (publicacaoOficial.exercicio === null || publicacaoOficial.exercicio <= 0) {
      enqueueSnackbar('O campo Exercício é obrigatório.', { variant: 'warning' });
      return;
    }

    if (!publicacaoOficial.tipo || !publicacaoOficial.tipo.id) {
      enqueueSnackbar('O Tipo deve ser informado!', { variant: 'warning' });
      return;
    }

    if (!publicacaoOficial.descricao) {
      enqueueSnackbar('A Descricao deve ser informado!', { variant: 'warning' });
      return;
    }

    if (publicacaoOficial.tipo?.isVereador && (!publicacaoOficialVereador || publicacaoOficialVereador.length === 0)) {
      enqueueSnackbar('Deve ser incluído ao menos um Autor ou Coautor!', { variant: 'warning' });
      return;
    }

    const parms: PublicacaoOficialDTO = {
      id: publicacaoOficial.id || '',
      idTipo: publicacaoOficial.tipo.id || '',
      descricao: publicacaoOficial.descricao || '',
      observacao: publicacaoOficial.observacao || '',
      exercicio: publicacaoOficial.exercicio || null
    };

    setLoading(true);
    const result: any = await createPublicacaoOficial(parms);
    const idPublicacaoOficial = result?.data?.id;

    if (idPublicacaoOficial) {
      if (publicacaoOficialAnexoParaSalvar.length) {
        const formData = new FormData();
        publicacaoOficialAnexoParaSalvar.forEach(file => formData.append('imagens', file));
        formData.append('publicacaoOficialID', idPublicacaoOficial);
        createAnexos(formData);
      }

      if (publicacaoOficialAnexoSalvo && publicacaoOficialAnexoSalvo?.length) {
        let publicacaoOficialAnexoExcluido: { idAnexo: string }[];

        publicacaoOficialAnexoExcluido = publicacaoOficialAnexoSalvo.filter(it => it.excluido === true).map(it => ({ idAnexo: it.id }));

        if (publicacaoOficialAnexoExcluido.length) {
          const formData = new FormData();
          formData.append('publicacaoOficialID', idPublicacaoOficial);
          formData.append('anexosExcluidos', JSON.stringify(publicacaoOficialAnexoExcluido));
          removeAnexosExcluidos(formData);
        }
      }

      if (publicacaoOficialVereador && publicacaoOficialVereador.length > 0) {
        let vereadoresParaSalvar: PublicacaoOficialVereadorDTO[] = [];

        publicacaoOficialVereador
          .filter(it => it.excluido === false)
          .forEach(it => {
            vereadoresParaSalvar.push({
              idVereador: it.vereador.id || ''
            });
          }); // createAnexos(formData);

        if (publicacaoOficialVereador.length) {
          const formData = new FormData();
          formData.append('publicacaoOficialID', idPublicacaoOficial);
          formData.append('vereadores', JSON.stringify(vereadoresParaSalvar));
          createVereadores(formData);
        }
      }

      handleExcluirTodosAnexos();

      navigate(configSiteUrls.SITE_PUBLICACAO_OFICIAL_LIST);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  const handletxtTipoPublicacaoOficialChange = (tipoPublicacaoOficial: TipoPublicacaoOficial) => {
    setTipoPublicacaoOficialSelecionado(tipoPublicacaoOficial as TipoPublicacaoOficial);
    SetPublicacaoOficial(prev => ({
      ...prev,
      tipo: tipoPublicacaoOficial as TipoPublicacaoOficialList
    }));
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: {
              xs: '100%', // 100% em telas pequenas
              sm: '90%', // 90% em telas médias ou maiores
              md: '90%',
              lg: '90%'
            },
            maxWidth: '1200px', // Limite opcional
            p: 2
          }}
        >
          <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
            {publicacaoOficial.id ? 'Edição:' : 'Inclusão:'} Publicação Oficial
          </Typography>

          <form onSubmit={handleSubmit} method="POST">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Exercício:"
                    name="exercicio"
                    onChange={handleChange}
                    size="small"
                    inputProps={{
                      maxLength: 4,
                      inputMode: 'numeric',
                      pattern: '[0-9]*'
                    }}
                    value={publicacaoOficial.exercicio}
                  />
                  <FormHelperText>{publicacaoOficial.exercicio?.toString().length ?? 0}/4 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" gap={2}>
                  <FormControl fullWidth>
                    <TxtTipoPublicacaoOficialSite
                      isdisabled={false}
                      value={publicacaoOficial.tipo}
                      handleSearchChange={it => {
                        handletxtTipoPublicacaoOficialChange(it);
                      }}
                    />
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required label="Descrição/Resumo:" name="descricao" onChange={handleChange} size="small" inputProps={{ maxLength: 50 }} value={publicacaoOficial.descricao} />
                  <FormHelperText>{publicacaoOficial.descricao?.length}/50 caracteres</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Observação/Titulo em Destaque:"
                    name="observacao"
                    onChange={handleChange}
                    size="small"
                    inputProps={{ maxLength: 255 }}
                    multiline
                    rows={4}
                    value={publicacaoOficial.observacao}
                  />
                  <FormHelperText>{publicacaoOficial.observacao?.length}/255 caracteres</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <Accordion defaultExpanded={false}>
                    <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                      <Typography color="secondary" variant="body1" gutterBottom>
                        Anexos
                      </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Paper>
                        <GeralAnexosUpload
                          arquivosSalvos={publicacaoOficialAnexoSalvo ?? null}
                          arquivosParaSalvar={publicacaoOficialAnexoParaSalvar}
                          onFileChange={handleFileAnexoChange}
                          onDeleteSalvo={handleOnDeleteSalvo}
                          onDeleteParaSalvar={handleOnDeleteParaSalvar}
                          onDeleteAll={handleExcluirTodosAnexos}
                          tipo="PUBLICACAO_OFICIAL"
                        />
                      </Paper>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Grid>
              {tipoPublicacaoOficialSelecionado?.isVereador && (
                <Grid item xs={12}>
                  <Box>
                    <Accordion defaultExpanded={false}>
                      <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                        <Typography color="secondary" variant="body1" gutterBottom>
                          Autores e Coautores
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails>
                        <Paper>
                          <PublicacaoOficialVereadorComponent vereadores={publicacaoOficialVereador || []} setVerador={setPublicacaoOficialVereador} />
                        </Paper>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12}>
                <Box display="flex" gap={2}>
                  <Button type="submit" variant="contained" color="secondary">
                    Gravar
                  </Button>

                  <Button variant="contained" onClick={() => navigate(configSiteUrls.SITE_PUBLICACAO_OFICIAL_LIST)} color="primary">
                    Voltar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
};
